import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ChevronUp = ({ type, ...rest }: IconProps): JSX.Element => {
  return (
    <IconBase viewBox='0 0 24 25' {...rest}>
      {type === 'stroke' ? (
        <path
          d='m18 14.708-6-6-6 6'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      ) : (
        <path
          d='M12 7.958c.199 0 .39.079.53.22l6 6 .052.056a.75.75 0 0 1-1.056 1.056l-.056-.052L12 9.768l-5.47 5.47a.75.75 0 1 1-1.06-1.06l6-6 .114-.094A.75.75 0 0 1 12 7.958'
          fill='currentColor'
        />
      )}
    </IconBase>
  );
};
